import { Routes, Route, Navigate } from 'react-router-dom';
import Shell, { AccountPage } from '@/components/layout/Shell';
import LoginPage from '@/pages/LoginPage';
import SsoExchangePage from '@/pages/SsoExchangePage';
import HomePage from '@/pages/HomePage';
import FaceEnrollPage from '@/pages/FaceEnrollPage';
import OvertimePage from '@/pages/OvertimePage';
import LeaveHistoryPage from '@/pages/LeaveHistoryPage';
import OvertimeDetailPage from '@/pages/OvertimeDetailPage';
import PayslipPage from '@/pages/PayslipPage';
import PayslipDetailPage from '@/pages/PayslipDetailPage';
import { Toaster } from '@/components/ui/toaster';
import { InstallPwaPrompt } from '@/components/InstallPwaPrompt';

export default function App() {
    return (
        <>
            <Routes>
                <Route path="/login" element={<LoginPage />} />
                <Route path="/auth/sso" element={<SsoExchangePage />} />

                <Route element={<Shell />}>
                    <Route path="/" element={<HomePage />} />
                    <Route path="/wajah" element={<FaceEnrollPage />} />
                    <Route path="/lembur" element={<OvertimePage />} />
                    <Route path="/lembur/:id" element={<OvertimeDetailPage />} />
                    <Route path="/cuti" element={<LeaveHistoryPage />} />
                    <Route path="/slip" element={<PayslipPage />} />
                    <Route path="/slip/:id" element={<PayslipDetailPage />} />
                    <Route path="/akun" element={<AccountPage />} />
                </Route>

                <Route path="*" element={<Navigate to="/" replace />} />
            </Routes>
            <Toaster />
            <InstallPwaPrompt />
        </>
    );
}
